import React from "react";
import {
    FileTextOutlined,
    TagOutlined,
    MessageOutlined,
    InfoCircleOutlined
} from "@ant-design/icons";
import { Col, Row } from "antd";
import CommonCard from "../../../global/card";
import { cn } from "../../../../utils/cn";

const EnhancedAutorespondersDetails = ({ data }) => {
    if (!data) return null;

    const getIconForField = (label) => {
        const iconMap = {
            "Internal Name": <TagOutlined />,
            "Display Title": <FileTextOutlined />,
        };
        return iconMap[label] || <FileTextOutlined />;
    };

    return (
        <div className="p-6" style={{ backgroundColor: "#f5f7fa" }}>
            <Row gutter={[24, 24]}>
                <Col span={24}>
                    <CommonCard
                        title={
                            <div className="flex items-center gap-2">
                                <InfoCircleOutlined
                                    style={{
                                        color: "var(--primary-color, #1890ff)",
                                        fontSize: "18px",
                                    }}
                                />
                                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                                    Autoresponder Information
                                </span>
                            </div>
                        }
                    >
                        <Row>
                            {[
                                {
                                    label: "Internal Name",
                                    value: data?.name,
                                },
                                {
                                    label: "Display Title",
                                    value: data?.title,
                                }
                            ].map((item, idx) => (
                                <Col
                                    span={24}
                                    key={item.label}
                                    className={cn(
                                        "border-b border-gray-200 py-4",
                                        idx === 1 && "!border-b-0"
                                    )}
                                >
                                    <div className="flex justify-between items-center w-full">
                                        <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                            <span
                                                style={{
                                                    color: "var(--primary-color, #1890ff)",
                                                    fontSize: "16px",
                                                }}
                                            >
                                                {getIconForField(item.label)}
                                            </span>
                                            {item.label}
                                        </span>
                                        <span className="text-sm font-semibold text-gray-900">
                                            {item.value || "—"}
                                        </span>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </CommonCard>
                </Col>

                <Col span={24}>
                    <CommonCard
                        title={
                            <div className="flex items-center gap-2">
                                <MessageOutlined
                                    style={{
                                        color: "var(--primary-color, #1890ff)",
                                        fontSize: "18px",
                                    }}
                                />
                                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                                    Message Content
                                </span>
                            </div>
                        }
                    >
                        <div className="bg-white p-4 rounded-lg border border-gray-200 min-h-[200px]">
                            <div
                                className="prose prose-sm max-w-none text-gray-700"
                                dangerouslySetInnerHTML={{ __html: data.message }}
                            />
                        </div>
                    </CommonCard>
                </Col>
            </Row>
        </div>
    );
};

export default EnhancedAutorespondersDetails;
